export const encodeURLValues = (input) => Object.keys(input).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(input[key])}`).join('&');

// browsers ignore whitespace and control characters inside a scheme, so a tab spliced into
// "java<tab>script:" navigates the same as "javascript:" and has to be normalised away
// before the scheme is read
/* eslint-disable-next-line no-control-regex */
const IGNORED_IN_SCHEME = /[\u0000-\u0020\u00a0\u1680\u180e\u2000-\u200f\u2028-\u202f\u205f\u3000\ufeff]/g;

const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:/i;

// an allow list, so a scheme nobody thought of is dropped rather than let through: the browser
// runs some of them in the page and hands others to an OS handler
const NAVIGABLE_SCHEME = /^(?:https?|mailto|tel):/i;

// a scheme the browser executes in the page runs on click, and a read-only editor never
// reaches a handler that could have intercepted it
export const safeHref = (href) => {
  if (typeof href !== 'string') {
    return href;
  }

  const normalised = href.replace(IGNORED_IN_SCHEME, '');

  return !HAS_SCHEME.test(normalised) || NAVIGABLE_SCHEME.test(normalised) ? href : null;
};

const LINK = /^(https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;

export const isValidLink = (url) => typeof url === 'string' && url !== '' && LINK.test(url);

export const linkHref = (url) => {
  if (!isValidLink(url)) {
    return undefined;
  }
  return /^https?:\/\//.test(url) ? url : `http://${url}`;
};
